import dayjs from 'dayjs';
import { ReportSchema } from '../reports-form-page';
import { emailRegex } from '../../../../utils/regular-expressions';
import { ReportType } from '../../../../../types';

export const getReportSchema = (
  reportTypes: ReportType[] = [],
  currentUserTier: string = 'standard'
) => {
  return ReportSchema.superRefine((data, ctx) => {
    const enterpriseReportNames = [
      'activitiesSharedReportMyDrive',
      'activitiesSharedReportPublic',
      'activitiesSharedReportSharedDrive',
      'activitiesSharedReportPublicSharedDrives',
    ];

    const selectedReportType = reportTypes.find(
      (reportType) => reportType.name === data.reportType
    );
    if (selectedReportType) {
      if (selectedReportType.hasDateRange) {
        const start =
          data.dateRange && data.dateRange[0] ? data.dateRange[0] : 0;
        const end = data.dateRange && data.dateRange[1] ? data.dateRange[1] : 0;

        const isEnterpriseReport = enterpriseReportNames.includes(
          data.reportType || ''
        );

        const canSelectPastSixMonths =
          isEnterpriseReport && currentUserTier === 'enterprise';

        const minDate = canSelectPastSixMonths
          ? null
          : dayjs().subtract(6, 'month');

        if (
          !data.xDaysSelected &&
          data.dateRange &&
          data.dateRange[0] &&
          data.dateRange[0].isValid() &&
          data.dateRange[1] &&
          data.dateRange[1].isValid()
        ) {
          if (start > end) {
            ctx.addIssue({
              code: 'custom',
              path: ['dateRange'],
              message: 'Start date must be before end date.',
            });
          } else if (minDate && start < minDate) {
            ctx.addIssue({
              code: 'custom',
              path: ['dateRange'],
              message: `Start date cannot be earlier than ${dayjs(
                minDate
              ).format('MM/DD/YYYY')}.`,
            });
          } else if (minDate && end < minDate) {
            ctx.addIssue({
              code: 'custom',
              path: ['dateRange'],
              message: `End date cannot be earlier than ${dayjs(minDate).format(
                'MM/DD/YYYY'
              )}.`,
            });
          }
        }
      }

      if (selectedReportType.hasPossibleSources) {
        if (!data.allSource && data.sources && data.sources.length <= 0) {
          ctx.addIssue({
            path: ['sources'],
            message: 'Target is required.',
            code: 'custom',
          });
        }
      }

      if (selectedReportType.hasColumns) {
        if (data.columns && data.columns.length <= 0) {
          ctx.addIssue({
            path: ['columns'],
            message: 'Please select at least one column before moving on.',
            code: 'custom',
          });
        }
      }
    }

    if (data.reportType === 'externallyOwnedDocs') {
      if (!data.externalEmailAddress) {
        ctx.addIssue({
          path: ['externalEmailAddress'],
          message: 'External Email Address is required.',
          code: 'custom',
        });
      } else if (!emailRegex.test(data.externalEmailAddress)) {
        ctx.addIssue({
          path: ['externalEmailAddress'],
          message: 'Please provide a valid email address.',
          code: 'custom',
        });
      }
    }
    if (data.scheduled) {
      if (!data.dates || data.dates.length === 0) {
        ctx.addIssue({
          path: ['dates'],
          message: 'At least one date is required.',
          code: 'custom',
        });
      }

      if (!data.times || data.times.length === 0) {
        ctx.addIssue({
          path: ['times'],
          message: 'At least one time is required.',
          code: 'custom',
        });
      }
    }
    if (data.reportType === 'docsModOverXdays') {
      if (data.daysback === null) {
        ctx.addIssue({
          path: ['daysback'],
          message: 'Please provide a number.',
          code: 'custom',
        });
      } else if (data.daysback && data.daysback < 0) {
        ctx.addIssue({
          path: ['daysback'],
          message: 'Must be positive number or 0.',
          code: 'custom',
        });
      }
    }
    if (data.reportType === 'inactiveUsers') {
      if (!data.neverLoggedInCheck) {
        if (data.inactiveSinceDate === null || data.inactiveSinceDate === 0) {
          ctx.addIssue({
            path: ['inactiveSinceDate'],
            message: 'Select a date or check "never logged in".',
            code: 'custom',
          });
        }
      }
    }
    if (
      data.reportType === 'hangoutsMeet' ||
      data.reportType === 'EmailActivityReport'
    ) {
      if (
        data.xDaysSelected &&
        (data.reportOnLastXDays == null || data.reportOnLastXDays <= 0)
      ) {
        ctx.addIssue({
          path: ['reportOnLastXDays'],
          message: 'Must be greater than 0.',
          code: 'custom',
        });
      }
    }
    if (data.reportType === 'creditCardAndSSNReport') {
      if (
        data.regexTypeSelectedList &&
        data.regexTypeSelectedList.length <= 0
      ) {
        ctx.addIssue({
          path: ['regexTypeSelectedList'],
          message: 'Please select at least one source to report on.',
          code: 'custom',
        });
      }
      if (data.regexTypeSelectedList?.includes('Custom') && !data.regex) {
        ctx.addIssue({
          path: ['regex'],
          message: 'Custom Regex is required.',
          code: 'custom',
        });
      }
    }
  });
};
